export const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/c8d03523-dc8b-4e0f-9348-94b6b4784b2a/images/8a398c025ef0af46a566c1ffa02e0efa4acf722a18cc77225adc1c63b93b6444.jpeg";
export const HERO_URL = "https://static.prod-images.emergentagent.com/jobs/c8d03523-dc8b-4e0f-9348-94b6b4784b2a/images/16cd87fcedef12e845a7e880ca839229ebcf92a2fc6d906d7d1284ca03ee3522.jpeg";

export const FEATURED_GAMES = [
  "GTA V", "GTA VI", "FC 25", "Mortal Kombat 1", "Forza Horizon 5", "WWE 2K24", "Minecraft",
];
